import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { locale as common, mergeResources } from '@authy/lib-common/i18n'
import { locale as client } from '@authy/lib-client/i18n'
import { locale as web } from '@authy/lib-web/i18n'
import { locale as admin } from '@authy/lib-admin/i18n'

import { locale } from './locale'

const resources = mergeResources(locale, [common, client, web, admin])

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
})

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface CustomTypeOptions {
        defaultNS: 'en'
        resources: {
            en: typeof resources.en.translation
        }
    }
}
